<h3 class="panel-title">Reset your password</h3>

<div class="margin-top light-control-host">
  @if (!resetSubmitted) {
    <form [formGroup]="resetPasswordForm" (ngSubmit)="resetPassword()">
      <div class="flex-center-column">
        <div>If you've forgotten your password, we'll email you a link that you can use to reset it.</div>
        <div class="flex-center-row full-width padding-top">
          <input
            id="email"
            class="arpio-input"
            type="text"
            placeholder="Email"
            formControlName="email"
            autocomplete="username"
          />
        </div>
        @if (errorMessage) {
          <div class="error-text">{{ errorMessage }}</div>
        }
        <button busy-button [busy]="resetting" class="arpio-button" type="submit" [disabled]="!submitButtonEnabled">
          RESET PASSWORD
        </button>
      </div>
    </form>
  } @else {
    Thanks! If that email address is in our records, we've sent you a link to reset your password. Check your inbox for
    the next step.
  }
</div>
